export type ActiveFilterChip = {
  key: string
  label: string
  remove: () => void
}

export const HIDE_AT = { md: 'md:hidden', lg: 'lg:hidden', xl: 'xl:hidden' } as const
export const SHOW_AT = { md: 'hidden md:flex', lg: 'hidden lg:flex', xl: 'hidden xl:flex' } as const

export type FilterBreakpoint = keyof typeof HIDE_AT